import { render, staticRenderFns } from "./ParametersForm.vue?vue&type=template&id=39f5e4ca&scoped=true&"
import script from "./ParametersForm.vue?vue&type=script&lang=js&"
export * from "./ParametersForm.vue?vue&type=script&lang=js&"
import style0 from "./ParametersForm.vue?vue&type=style&index=0&id=39f5e4ca&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f5e4ca",
  null
  
)

export default component.exports